/* Ported from reference/salesfix-value-map-builder.html (class names in camelCase). The reference is the visual spec; edit here, not there. */
.quantify {
  padding: 30px 34px 90px;
}
.qWrap {
  max-width: 1100px;
  margin: 0 auto;
}
.qHead {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 24px;
  margin-bottom: 22px;
}
.qHead h1 {
  font-size: 28px;
  margin-top: 2px;
}
.qIntro {
  color: var(--muted);
  font-size: 14.5px;
  max-width: 660px;
  margin: 9px 0 0;
  line-height: 1.5;
}
.qHorizon {
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: var(--muted);
  display: flex;
  align-items: center;
  gap: 9px;
  white-space: nowrap;
}
.qHorizon select {
  font-family: inherit;
  font-size: 14px;
  font-weight: 700;
  padding: 8px 11px;
  border: 1px solid var(--border-strong);
  border-radius: 8px;
  color: var(--ink);
  background: #fff;
}
.qTotals {
  display: flex;
  gap: 16px;
  margin-bottom: 26px;
  flex-wrap: wrap;
}
.qTotalCard {
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: 12px;
  padding: 15px 20px;
  min-width: 190px;
}
.qTotalCard.hero {
  background: var(--blue-d);
  border-color: var(--blue-d);
}
.qTotalCard.alt {
  background: #eff8f1;
  border-color: #cde8d5;
}
.qtK {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  color: var(--muted);
}
.qTotalCard.hero .qtK {
  color: var(--green-on-dark);
}
.qtV {
  font-size: 30px;
  font-weight: 900;
  color: var(--ink);
  margin-top: 3px;
  letter-spacing: -0.02em;
}
.qTotalCard.hero .qtV {
  color: #fff;
}
.qTotalCard.alt .qtV {
  color: var(--green-text);
}
.qtRange {
  font-size: 12px;
  color: #bfe0ee;
  margin-top: 3px;
}
.qGoal {
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: 14px;
  padding: 20px 22px;
  margin-bottom: 18px;
  box-shadow: var(--shadow);
}
.qGoalHead {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  gap: 16px;
  margin-bottom: 14px;
  border-bottom: 1px solid var(--border);
  padding-bottom: 12px;
}
.qGoalHead h2 {
  font-size: 19px;
}
.qSub {
  font-size: 13.5px;
  font-weight: 700;
  color: var(--green-text);
  white-space: nowrap;
}
.qBlock {
  border: 1px solid var(--border);
  border-radius: 11px;
  padding: 14px 16px;
  margin-bottom: 12px;
  background: #fbfdfe;
}
.qBlockHead {
  display: flex;
  align-items: center;
  gap: 11px;
  margin-bottom: 12px;
}
.qBadge {
  font-size: 11px;
  font-weight: 900;
  text-transform: uppercase;
  letter-spacing: 0.07em;
  padding: 3px 9px;
  border-radius: 6px;
  flex: 0 0 auto;
}
.qBadge.revenue {
  background: #eaf5ee;
  color: var(--green-text);
}
.qBadge.efficiency {
  background: #e8f3f8;
  color: var(--blue-text);
}
.qBadge.cost {
  background: #fdf4e7;
  color: var(--amber-text);
}
.qBlockLabel {
  flex: 1;
  border: none;
  background: transparent;
  font-size: 16px;
  font-weight: 700;
  color: var(--ink);
}
.qBlockLabel:focus {
  outline: none;
  border-bottom: 1px solid var(--green-l);
}
.qRm {
  border: none;
  background: transparent;
  color: var(--muted);
  font-weight: 700;
  font-size: 12px;
  cursor: pointer;
}
.qRm:hover {
  color: #c0392b;
}
.qMethod {
  display: inline-flex;
  background: var(--bg);
  border: 1px solid var(--border);
  border-radius: 8px;
  padding: 2px;
  margin-bottom: 12px;
}
.qMethod button {
  border: none;
  background: transparent;
  font-size: 12.5px;
  font-weight: 700;
  color: var(--muted);
  padding: 6px 13px;
  border-radius: 6px;
  cursor: pointer;
}
.qMethod button.on {
  background: #fff;
  color: var(--blue-d);
  box-shadow: 0 1px 2px rgba(18, 51, 66, 0.1);
}
.qGrid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(178px, 1fr));
  gap: 12px;
}
.qField {
  display: flex;
  flex-direction: column;
  gap: 5px;
  font-size: 12px;
  font-weight: 700;
  color: var(--muted);
}
.qField input {
  font-family: inherit;
  font-size: 15px;
  font-weight: 400;
  color: var(--ink);
  border: 1px solid var(--border-strong);
  border-radius: 8px;
  padding: 9px 11px;
  background: #fff;
}
.qField input:focus {
  outline: none;
  border-color: var(--blue-l);
  box-shadow: 0 0 0 3px rgba(12, 134, 188, 0.35);
}
.qHelp {
  font-size: 11px;
  font-weight: 400;
  color: var(--muted);
  line-height: 1.3;
  margin-top: 1px;
}
.qOut {
  margin-top: 14px;
  background: #fff;
  border: 1px dashed var(--border-strong);
  border-radius: 10px;
  padding: 13px 15px;
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  align-items: center;
}
.qOut .o {
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.qOut .o .ok {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: var(--muted);
}
.qOut .o .ov {
  font-size: 20px;
  font-weight: 900;
  color: var(--ink);
  letter-spacing: -0.01em;
}
.qOut .o.green .ov {
  color: var(--green-text);
}
.qOut .note {
  font-size: 12px;
  color: var(--muted);
  font-style: italic;
}
.qAdd {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  font-size: 13px;
  color: var(--muted);
  font-weight: 700;
}
.qAddBtn {
  border: 1px dashed var(--border-strong);
  background: transparent;
  color: var(--blue-text);
  font-weight: 700;
  font-size: 13px;
  padding: 8px 14px;
  border-radius: 9px;
  cursor: pointer;
}
.qAddBtn:hover {
  background: #f3fafc;
  border-color: var(--blue-l);
}
.qTablewrap {
  margin-top: 26px;
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: 14px;
  padding: 18px 20px;
  box-shadow: var(--shadow);
  overflow-x: auto;
}
.qTable {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
}
.qTable th,
.qTable td {
  text-align: right;
  padding: 9px 12px;
  border-bottom: 1px solid var(--border);
  white-space: nowrap;
}
.qTable th:first-child,
.qTable td:first-child {
  text-align: left;
}
.qTable thead th {
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: var(--muted);
}
.qTable tr.tot td {
  font-weight: 900;
  color: var(--ink);
  border-top: 2px solid var(--border-strong);
  border-bottom: none;
}
.qEmptyNote {
  color: var(--muted);
  font-style: italic;
  text-align: center;
  padding: 10px;
}
@media (max-width: 820px) {
  .qHead {
    flex-direction: column;
  }
}
